const INPUT_SELECTOR = '.in-number';
const INVALID_CHARS = [
    '+',
    '-',
    'e',
];

const NumberInput = {
    init: ($scope) => {
        if (!$scope) {
            $scope = $(document);
        }

        $scope.on('keydown', INPUT_SELECTOR, function (event) {
            const $input = $(this);
            let invalidChars = INVALID_CHARS;

            if ($input.data('allow-negative-values')) {
                invalidChars = invalidChars.filter(c => c !== '-');
            }

            if (invalidChars.includes(event.key?.toLowerCase())) {
                event.preventDefault();
            }
        });
    },
};

export default NumberInput;
